"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertNotificationDto = void 0;
const UserDto_1 = require("../users/UserDto");
class AlertNotificationDto {
    constructor(params) {
        this.text = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.alertId = params.alertId;
        this.userId = params.userId;
        this.text = params.text;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.user !== undefined) {
            this.user = params.user ? new UserDto_1.UserDto(params.user) : null;
        }
    }
}
exports.AlertNotificationDto = AlertNotificationDto;
//# sourceMappingURL=AlertNotificationDto.js.map